import PillarPlaceholder from "./PillarPlaceholder";

export default function FinanceSettings() {
  return (
    <PillarPlaceholder
      pillar="finance"
      title="Finance settings"
      description="Finance-pillar knobs (invoice numbering schemes, tax codes, currency defaults, statement cadence) will live here once they're configurable."
    />
  );
}
